import React, {
  useCallback,
  useContext,
} from 'react';
import { compose } from 'recompose';
import { observer } from 'mobx-react';

import AnnouncementContext from '../../../../context/AnnouncementContext';
import LoadingPage from '../../../../../components/LoadingPage';
import { TitleContainer, Title } from '../../../../../components/v2/Header';

import { Container, TabContainer } from '../../styles';
import FullPostView from '../FullPostView';

import NotificationItem from './NotificationItem';
import MarkAllReadButton from './MarkAllRead';
import texts from './texts.json';
import {
  CommentsNotificationContainer,
  EmptyContainer,
  StyledHeaderRow,
} from './styles';

const CommentNotifications = () => {
  const {
    updateCommentAndAnnouncementState,
    selectedAnnouncement,
    coachUnreadComments,
    isReady,
  } = useContext(AnnouncementContext);

  const renderUnreadCommentsContent = useCallback(() => {
    if (!isReady) {
      return <LoadingPage />;
    }
    if (coachUnreadComments.length === 0) {
      return (
        <EmptyContainer>
          {texts.noUnreadComments}
        </EmptyContainer>
      );
    }
    return (
      <CommentsNotificationContainer>
        {coachUnreadComments?.map((comment) => (
          <NotificationItem
            key={comment.id}
            comment={comment}
          />
        ))}
      </CommentsNotificationContainer>
    );
  }, [
    coachUnreadComments,
    isReady,
  ]);

  return (
    <>
      <TabContainer>
        <Container>
          <StyledHeaderRow>
            <TitleContainer>
              <Title>{texts.title}</Title>
            </TitleContainer>
            <MarkAllReadButton />
          </StyledHeaderRow>
          {renderUnreadCommentsContent()}
        </Container>
      </TabContainer>
      {/* Gated on the post, not on the comment id: switching the open post to another community's
          copy clears the deep link, and gating on it would close the dialog mid-read. */}
      {!!selectedAnnouncement && (
        <FullPostView
          isOpen={!!selectedAnnouncement}
          onClose={() => updateCommentAndAnnouncementState(null, null)}
        />
      )}
    </>
  );
};

export default compose(
  observer,
)(CommentNotifications);
